import { render, staticRenderFns } from "./mediateInfo.vue?vue&type=template&id=45b83eb8&scoped=true&"
import script from "./mediateInfo.vue?vue&type=script&lang=tsx&"
export * from "./mediateInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./mediateInfo.vue?vue&type=style&index=0&id=45b83eb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b83eb8",
  null
  
)

export default component.exports